import type { ITransmissionPeakHour } from '@/types/cpm'
import type { ILoadForecastFilters, ITransmissionPeakHourFilters } from '@/types/cpm/filters'
import type { ITransmissionPeakHourForm } from '@/types/cpm/forms'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export const getLoadForecastTimeseries = async (filters: ILoadForecastFilters) => {
  const result = await axios.get(import.meta.env.VITE_APP_CPM_LOAD_FORECAST_ENDPOINT, { params: filters })
  return result.data
}

export const getTransmissionPeakHours = async (
  filters: ITransmissionPeakHourFilters
): Promise<IPage<ITransmissionPeakHour>> => {
  const result = await axios.get(import.meta.env.VITE_APP_CPM_PEAK_HOURS_ENDPOINT, { params: filters })
  return result.data
}

export const createTransmissionPeakHour = async (form: ITransmissionPeakHourForm) => {
  const result = await axios.post(import.meta.env.VITE_APP_CPM_PEAK_HOURS_ENDPOINT, form)
  return result.data
}

export const deleteTransmissionPeakHour = async (id: string) => {
  const params = {
    id,
  }

  await axios.delete(import.meta.env.VITE_APP_CPM_PEAK_HOURS_ENDPOINT, { data: params })
}
